export default (name) => document.documentElement.className.includes(name);
